import AxiosApiInstance, {APIBase} from "../../../../AxiosApiInstance";
import {AxiosResponse} from "axios";

const ApiBackCampaignsConfigsProgramsIdDelete
  = (id: string, campaign_pk: string)
  :Promise<AxiosResponse> => {
    return AxiosApiInstance.delete(`${APIBase}back/campaigns/${campaign_pk}/configs/programs/${id}/`);
  };

export default ApiBackCampaignsConfigsProgramsIdDelete;